import React from 'react'
import styled from 'styled-components'
import logo from '../../assets/welcomeScreen/logo.png'
import cancelIcon from '../../assets/cancelPaymentScreen/cancel.png'
import { mediaQ, fontSizeResponsive } from '../theme/mixins'

const CancelPaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100vh;
  background-image: linear-gradient(
    0deg,
    rgba(52, 33, 82, 1) 0%,
    rgba(52, 33, 82, 1) 37%,
    rgba(120, 23, 154, 0.9724264705882353) 69%,
    rgba(52, 33, 82, 1) 92%,
    rgba(52, 33, 82, 1) 100%
  );
  font-family: 'Nunito';
  color: white;
`
const CancelPaymentMainContent = styled.main`
  /* border: 1px solid rgba(255, 255, 255, 0.3); */
  border-radius: 6px;
  padding: 40px 25px;
  box-shadow: 0 2.6px 2.5px rgba(0, 0, 0, 0.017),
    0 6px 5.6px rgba(0, 0, 0, 0.024), 0 10.4px 9.7px rgba(0, 0, 0, 0.03),
    0 16.5px 15.4px rgba(0, 0, 0, 0.035), 0 25.5px 23.8px rgba(0, 0, 0, 0.04),
    0 39.8px 37.1px rgba(0, 0, 0, 0.046), 0 66.1px 61.6px rgba(0, 0, 0, 0.053),
    0 132px 123px rgba(0, 0, 0, 0.07);
  background-color: rgba(255, 255, 255, 0.25);
  margin-top: 100px;

  ${mediaQ('mobileAll', 'width: 80%; padding: 30px 10px;')}
`

const MiazgaLogo = styled.img`
  justify-self: flex-start;

  ${mediaQ('mobileAll', 'width: inherit;')}
`
const CancelPaymentHeader = styled.header`
  display: flex;
  align-items: center;
  ${fontSizeResponsive(50)};
  font-weight: 600;
  margin: 15px;
  justify-content: center;

  ${mediaQ('mobileAll', 'margin: 0px;')}
`
const CancelPaymentSubHeader = styled.h3`
  text-align: center;
  margin: 40px auto 30px auto;
  ${fontSizeResponsive(24)};
  font-weight: 500;
  max-width: 70%;

  a {
    margin-left: 3px;
    color: white;
    font-weight: bold;
  }

  ${mediaQ('mobileAll', 'max-width:100%; line-height: 15px;')}
`

const CancelPaymentIcon = styled.img`
  width: 60px;
  height: 60px;
  margin-right: 15px;

  ${mediaQ('mobileAll', 'width:30px;height:30px;')}
  ${mediaQ('laptop', 'width:40px;height:40px;')}
`

const CancelPaymentText = styled.span``

const CancelPayment = () => {
  return (
    <CancelPaymentContainer>
      <MiazgaLogo
        src={logo}
        alt="Logo aplikacji Miazga od Fit Matka Wariatka"
      />
      <CancelPaymentMainContent>
        <CancelPaymentHeader>
          <CancelPaymentIcon
            src={cancelIcon}
            alt="Ikona akceptacji płatności"
          />
          <CancelPaymentText>Płatność anulowana</CancelPaymentText>
        </CancelPaymentHeader>
        <CancelPaymentSubHeader>
          Płatność została przerwana. Za chwilę zostaniesz przeniesiony na
          stronę główną. Jesli tak się nie stało, lub nie chcesz czekać,
          <a href="/">możesz kliknąć tu.</a>
        </CancelPaymentSubHeader>
      </CancelPaymentMainContent>
    </CancelPaymentContainer>
  )
}

export default CancelPayment
